import React from 'react'
import { FlexDiv } from '../../../../elements/NumberInput/NumberInputStyles'
import Switcher from './Switch'

interface Switcher_props {
  onWin: boolean
  onLoss: boolean
  onWinPercent: string
  onLossPercent: string
  handleStateUpdate: (s: string, name: string) => void
  audio: any
  handleonWin:(b: boolean) => void
  handleonLoss:(b: boolean) => void
}

export default function Switchers({
  handleStateUpdate,
  onWin,
  onLoss,
  onWinPercent,
  onLossPercent,
  audio,
  handleonLoss,
  handleonWin
}: Switcher_props) {
  return (
    <FlexDiv marginBottom='15px'>
      <Switcher
        handleChance={handleStateUpdate}
        handleSwitch={handleonWin}
        value={onWinPercent}
        name={'ON_WIN'}
        title='ON WIN'
        height='42px'
        checked={onWin}
        audio={audio}
      />
      <Switcher
        handleChance={handleStateUpdate}
        handleSwitch={handleonLoss}
        value={onLossPercent}
        name={'ON_LOSS'}
        title='ON LOSS'
        checked={onLoss}
        audio={audio}
      />
    </FlexDiv>
  )
}
